import React, {Component} from 'react';
import PrintPreview from '../PrintPreview'
import ReportStore from 'stores/ReportStore'
import './Print.css'

const DEFAULT_ROW = 31
class PrintReportUnfinishedWork extends Component {

    constructor(...args) {
      super(...args)
        
      this.state = {loading:false,dataList:[],data:[],report_title:'กำลังดึงข้อมูล..'}

      var cssPagedMedia = (function() {
        var style = document.createElement('style');
        document.head.appendChild(style);
        return function (rule) {
          style.innerHTML = rule;
        };
      }());
  
      cssPagedMedia.size = function(size) {
        cssPagedMedia('@page {size: ' + size + '}');
      };
      cssPagedMedia.size('portrait');
    }

    componentDidMount() {
        this.loadData()
    }

    loadData() {
        ReportStore.loadUncompletedWork((result)=>{
            this.setState({data:result.data,dataList:this.getPagination(result.data),report_title:'ไม่พบข้อมูล'})
        },()=>{

        })
    }

    getNumberFormat(value) {
        let _val = value===''||value===null||value===undefined||isNaN(value) ? 0 : value
        _val = parseFloat(_val)
        return _val.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
    }
    
    getPagination(data) {
        let newData = []
        let allData = []
        let checkRow = 0
        data.forEach(function(item,index) {
            if (checkRow<DEFAULT_ROW)
              checkRow++
              newData.push(item)
    
            if (checkRow===DEFAULT_ROW-1||index===data.length-1) {
              allData.push(newData)
              checkRow = 0
              newData = []
            }
        })  
        
        return allData
    }

    renderRowData(data,indexs) {
        if (data.length==0) {
          return(<tr><td colSpan={11}>ไม่พบข้อมูล</td></tr>)
        } else {
          return data.map((item, index) => (
                <tr key={index}>
                  <td className='text-center'>{item.title}</td>
                  <td className='text-right bg-0'>{this.getNumberFormat(item.day30_count)}</td>
                  <td className='text-right bg-0'>{this.getNumberFormat(item.day30_amount)}</td>
                  <td className='text-right bg-1'>{this.getNumberFormat(item.day60_count)}</td>
                  <td className='text-right bg-1'>{this.getNumberFormat(item.day60_amount)}</td>
                  <td className='text-right bg-2'>{this.getNumberFormat(item.day90_count)}</td>
                  <td className='text-right bg-2'>{this.getNumberFormat(item.day90_amount)}</td>
                  <td className='text-right bg-3'>{this.getNumberFormat(item.day91_count)}</td>
                  <td className='text-right bg-3'>{this.getNumberFormat(item.day91_amount)}}</td>
                  <td className='text-right'>{this.getNumberFormat(item.all_count)}</td>
                  <td className='text-right'>{this.getNumberFormat(item.all_amount)}</td>
                </tr>
          ))
        }
    }

    renderTable(item,index,length) {
        return(
            <table className='table table-print-report-fixing'>
                <tbody>
                    <tr>
                        <td className='text-center' style={{width:'100px'}}>ชำระเงิน<br/>ประเภท</td>
                        <td className='text-center bg-0' style={{width:'120px'}}>1-30 วัน</td>
                        <td className='text-center bg-0' style={{width:'200px'}}>จำนวนเงิน</td>
                        <td className='text-center bg-1' style={{width:'120px'}}>31-60 วัน</td>
                        <td className='text-center bg-1' style={{width:'200px'}}>จำนวนเงิน</td>
                        <td className='text-center bg-2' style={{width:'120px'}}>61-90 วัน</td>
                        <td className='text-center bg-2' style={{width:'200px'}}>จำนวนเงิน</td>
                        <td className='text-center bg-3' style={{width:'150px'}}>91 วันขึ้นไป</td>
                        <td className='text-center bg-3' style={{width:'200px'}}>จำนวนเงิน</td>
                        <td className='text-center' style={{width:'120px'}}>รวมทั้งสิ้น</td>
                        <td className='text-center' style={{width:'200px'}}>จำนวนเงิน</td>
                    </tr>
                    {this.renderRowData(item,index)}
                </tbody>
            </table>
        )
    }

    renderComponentPage(item,index,length) {
        return(  
            <div className='font-print' key={index}>
                <header className="text-center">
                    <h2>{this.props.title}</h2>
                </header>
                <div>
                    {this.renderTable(item,index,length)}
                </div>
            </div>
        )    
    }
    
    renderNoData() {
        return(
          <div className='font-print'>
            <header className="text-center">
              <h2>{this.state.report_title}</h2>
            </header>
          </div>
        )
    }

    render() {
        let {loading,dataList} = this.state
        if (dataList.length==0) {
            return(
                <PrintPreview 
                    loading={loading}
                    leftBarTitle={this.props.title}
                >
                    {this.renderNoData()}    
                </PrintPreview>
            )
        } else {
            return(
                <PrintPreview 
                    loading={loading}
                    leftBarTitle={this.props.title}
                >
                    {
                        dataList.map((item,index)=>{
                            return(
                                this.renderComponentPage(item,index,dataList.length)
                            )
                        })   
                    }
                </PrintPreview>
            )
        }      
    }
}

PrintReportUnfinishedWork.defaultProps = {
    title: 'ตารางรายงานสรุปงานซ่อมค้างปิด',
    mode: '',
    workNo: ''
  }
  export default PrintReportUnfinishedWork;


// WEBPACK FOOTER //
// ./src/view/print/fixing/PrintReportUnfinishedWork.js